export enum AgeSegmentRoomState {
    ADULT = 'ADULT',
    CHILD = 'CHILD',
    BABY = 'BABY',
}

export interface CancellationPolicyState {
    id: number;
    text: string;
}

export interface BookingRoomRateState {
    id: string;
    amount: number;
    night: number;
}

export interface BookingRoomGuestState {
    name: string;
    surname: string;
    age: number;
    ageSegment: AgeSegmentRoomState;
}

export interface BookingRoomState {
    id: string;
    roomType: string;
    roomMappingCode: string;
    mealPlan: string;
    mealPlanMappingCode: string;
    ratePlan: string;
    ratePlanMappingCode: string;
    guests: BookingRoomGuestState[];
}

export type BookingHotelImageState = {
    id: string;
    caption: string;
    published: boolean;
    feature: boolean;
    virtualPath: string;
} | null;

export interface BookingRatesState {
    id: string;
    room: string;
    rates: BookingRoomRateState[];
}

export interface BookingState {
    status: string;
    statusColor: string;
    hotel: string;
    address: string;
    hotelRating: number;
    hotelCategory: string;
    bookingCode: string;
    hotelRefecerenceCode: string;
    checkIn: Date | null;
    checkOut: Date | null;
    bookingDate: Date | null;
    nights: number;
    customerName: string;
    customerEmail: string;
    paxes: number;
    totalAmount: number;
    paymentId: number;
    currency: string;
    cancellationPolicies: CancellationPolicyState[];
    rooms: BookingRoomState[];
    hotelImages: BookingHotelImageState[];
    prices: BookingRatesState[];
    notes: string;
}

export interface CreditCardState {
    creditCardHolderName: string;
    creditCardNumber: string;
    creditCardExpiryDate: string;
    cvc: string;
}
